// Auto-generated resource for Billing — DO NOT EDIT.
// Regenerate via `dotnet run --project backend/tools/BackendTypesGenerator`.
// Projection of the backend resource JSON — keys, value catalogs (per
// culture), and string-literal unions. Hand-editing drifts from the source.

export const BillingKeys = {
  Waitlist: {
    EmailRequired: 'Billing.Waitlist.EmailRequired',
    EmailInvalid: 'Billing.Waitlist.EmailInvalid',
    AtCapacity: 'Billing.Waitlist.AtCapacity',
    JoinSuccess: 'Billing.Waitlist.JoinSuccess',
    AlreadyAdmitted: 'Billing.Waitlist.AlreadyAdmitted',
  },
  Recovery: {
    UnknownEntitlement: 'Billing.Recovery.UnknownEntitlement',
    UnknownSku: 'Billing.Recovery.UnknownSku',
    NotAClaimedAccount: 'Billing.Recovery.NotAClaimedAccount',
    EmailRequired: 'Billing.Recovery.EmailRequired',
    InvalidDuration: 'Billing.Recovery.InvalidDuration',
    LiveStripeSubscription: 'Billing.Recovery.LiveStripeSubscription',
    PurchaseKeyRequired: 'Billing.Recovery.PurchaseKeyRequired',
    VoidReasonRequired: 'Billing.Recovery.VoidReasonRequired',
  },
  Refund: {
    EmailRequired: 'Billing.Refund.EmailRequired',
    ReasonRequired: 'Billing.Refund.ReasonRequired',
    PurchaseNotFound: 'Billing.Refund.PurchaseNotFound',
    AiSpendSincePurchase: 'Billing.Refund.AiSpendSincePurchase',
    ProcessorRefused: 'Billing.Refund.ProcessorRefused',
  },
  Estimate: {
    RangeOne: 'Billing.Estimate.RangeOne',
    RangeMany: 'Billing.Estimate.RangeMany',
    ExactOne: 'Billing.Estimate.ExactOne',
    ExactMany: 'Billing.Estimate.ExactMany',
    Balance: 'Billing.Estimate.Balance',
  },
  SpendConfirm: {
    Title: 'Billing.SpendConfirm.Title',
    Body: 'Billing.SpendConfirm.Body',
    Confirm: 'Billing.SpendConfirm.Confirm',
    Cancel: 'Billing.SpendConfirm.Cancel',
  },
  Credits: {
    InDebt: 'Billing.Credits.InDebt',
  },
} as const;

export const BillingValues = {
  'default': {
    'Credits.InDebt': 'Your balance is −{0} credits. Top up to continue.',
    'Estimate.Balance': 'you have {Balance}',
    'Estimate.ExactMany': '{UpTo} credits',
    'Estimate.ExactOne': '1 credit',
    'Estimate.RangeMany': '≈ {Typical} credits, up to {UpTo}',
    'Estimate.RangeOne': '≈ 1 credit, up to {UpTo}',
    'Recovery.EmailRequired': 'Email is required.',
    'Recovery.InvalidDuration': 'Premium duration must be 1, 3, 6, or 12 months.',
    'Recovery.LiveStripeSubscription': 'This account has a live Stripe subscription; a hand-grant would be overwritten by the next renewal. Manage it in Stripe instead.',
    'Recovery.NotAClaimedAccount': 'A hand-grant needs a signed-up account; this user does not exist or is still a guest.',
    'Recovery.PurchaseKeyRequired': 'A purchase key is required.',
    'Recovery.UnknownEntitlement': 'Entitlement must be \'premium\' or \'credits\'.',
    'Recovery.UnknownSku': 'Unknown credit-pack SKU.',
    'Recovery.VoidReasonRequired': 'A reason is required to void a parked purchase.',
    'Refund.AiSpendSincePurchase': 'AI credits have been spent or an AI Review has run since this purchase, so it can no longer be refunded. That money is spent at an AI provider and does not come back.',
    'Refund.EmailRequired': 'Email is required.',
    'Refund.ProcessorRefused': 'The payment processor refused the refund. Check it there before retrying.',
    'Refund.PurchaseNotFound': 'No such purchase is held against that email.',
    'Refund.ReasonRequired': 'A reason is required for a refund.',
    'SpendConfirm.Body': 'You have {Balance} credits. You\'re only charged for what it actually uses.',
    'SpendConfirm.Cancel': 'Cancel',
    'SpendConfirm.Confirm': 'Spend up to {UpTo}',
    'SpendConfirm.Title': 'Spend up to {UpTo} credits?',
    'Waitlist.AlreadyAdmitted': 'You\'ve already been admitted. Continue to checkout.',
    'Waitlist.AtCapacity': 'Premium is currently at capacity. Join the waitlist?',
    'Waitlist.EmailInvalid': 'Please enter a valid email address.',
    'Waitlist.EmailRequired': 'Email is required.',
    'Waitlist.JoinSuccess': 'You\'re on the waitlist. We\'ll email you when a slot opens.',
  },
  'vi-VN': {
    'Credits.InDebt': 'Số dư của bạn là −{0} tín dụng. Hãy nạp thêm để tiếp tục.',
    'Estimate.Balance': 'bạn có {Balance}',
    'Estimate.ExactMany': '{UpTo} tín dụng',
    'Estimate.ExactOne': '1 tín dụng',
    'Estimate.RangeMany': '≈ {Typical} tín dụng, tối đa {UpTo}',
    'Estimate.RangeOne': '≈ 1 tín dụng, tối đa {UpTo}',
    'Recovery.EmailRequired': 'Email không được để trống.',
    'Recovery.InvalidDuration': 'Thời hạn Cao cấp phải là 1, 3, 6 hoặc 12 tháng.',
    'Recovery.LiveStripeSubscription': 'Tài khoản này có gói đăng ký Stripe đang hoạt động; việc cấp thủ công sẽ bị ghi đè ở lần gia hạn tiếp theo. Hãy quản lý trong Stripe.',
    'Recovery.NotAClaimedAccount': 'Cấp thủ công cần một tài khoản đã đăng ký; người dùng này không tồn tại hoặc vẫn là khách.',
    'Recovery.PurchaseKeyRequired': 'Cần có mã giao dịch mua.',
    'Recovery.UnknownEntitlement': 'Quyền lợi phải là \'premium\' hoặc \'credits\'.',
    'Recovery.UnknownSku': 'SKU gói tín dụng không xác định.',
    'Recovery.VoidReasonRequired': 'Cần có lý do để hủy một giao dịch đang treo.',
    'Refund.AiSpendSincePurchase': 'Đã có tín dụng AI được dùng hoặc đã chạy AI Review kể từ giao dịch này, nên không thể hoàn tiền nữa. Khoản tiền đó đã chi cho nhà cung cấp AI và không lấy lại được.',
    'Refund.EmailRequired': 'Email không được để trống.',
    'Refund.ProcessorRefused': 'Cổng thanh toán đã từ chối việc hoàn tiền. Hãy kiểm tra ở đó trước khi thử lại.',
    'Refund.PurchaseNotFound': 'Không có giao dịch mua nào thuộc email đó.',
    'Refund.ReasonRequired': 'Cần có lý do để hoàn tiền.',
    'SpendConfirm.Body': 'Bạn có {Balance} tín dụng. Bạn chỉ trả cho phần thực sự dùng.',
    'SpendConfirm.Cancel': 'Hủy',
    'SpendConfirm.Confirm': 'Dùng tối đa {UpTo}',
    'SpendConfirm.Title': 'Dùng tối đa {UpTo} tín dụng?',
    'Waitlist.AlreadyAdmitted': 'Bạn đã được nhận. Hãy tiếp tục thanh toán.',
    'Waitlist.AtCapacity': 'Gói Cao cấp hiện đã đầy. Tham gia danh sách chờ nhé?',
    'Waitlist.EmailInvalid': 'Vui lòng nhập địa chỉ email hợp lệ.',
    'Waitlist.EmailRequired': 'Email không được để trống.',
    'Waitlist.JoinSuccess': 'Bạn đã ở trong danh sách chờ. Chúng tôi sẽ gửi email khi có chỗ trống.',
  },
} as const;

